import {forwardRef} from "react";
import styles from "./Button.module.css";

type ButtonProps = {
    variant?: "primary" | "secondary" | "outline" | "plain" | "destructive" | "link";
    fullWidth?: boolean;
    large?: boolean;
    loading?: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export const Button = forwardRef(function Button(
    props: ButtonProps,
    ref: React.Ref<HTMLButtonElement>
) {
    const {
        children,
        variant = "primary",
        fullWidth = false,
        large = false,
        loading = false,
        className,
        disabled,
        ...restProps
    } = props;

    const classNames = [
        styles.button,
        styles[variant],
        fullWidth && styles.fullWidth,
        large && styles.large,
        loading && styles.loading,
        className,
    ]
        .filter(Boolean)
        .join(" ");

    const spinnerClassNames = [
        styles.spinner,
        variant === "primary" ? styles.spinnerPrimary : styles.spinnerDefault,
    ].join(" ");

    return (
        <button
            type="button"
            {...restProps}
            className={classNames}
            disabled={loading || disabled}
            ref={ref}
        >
            {children}
            {loading && <div className={spinnerClassNames} />}
        </button>
    );
});
